import { render, staticRenderFns } from "./CompanyViewPage.vue?vue&type=template&id=5376588f"
import script from "./CompanyViewPage.vue?vue&type=script&lang=js"
export * from "./CompanyViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports